import React, { useState } from "react";
import { motion } from "framer-motion";

type LoginProps = {
  setPage: (page: string) => void;
};

const Login: React.FC<LoginProps> = ({setPage}) => {
  const [passwordInput,setPasswordInput] = useState<string>("");
  const [wrongPass,setWrongPass] = useState<boolean>(false);

  const handleLogin = async () => {
    const response = await fetch(`https://lscinvoice.com/api/login/${passwordInput}`, {
      method: 'POST'
    })
    const data = await response.json()
    if (data.message === "OK") {
      setPage("builder");
      setWrongPass(false);
    } else {
      setWrongPass(true);
    }
    setPasswordInput("");
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.3 }}
    >
      <div className="flex mt-35">
        <label className="align-right login-label">Password:</label>
        <input
        value={passwordInput}
        onChange={(e) => {setPasswordInput(e.target.value)}}
        onKeyDown={handleKeyDown}
        className="align-left login-input"
        type="password"
        />
      </div>
      {wrongPass ? (
        <div className="flex">
          <motion.p
            className="align-left align-right red-text"
            animate={{ x: [0, -10, 10, -10, 10, 0] }}
            transition={{ duration: 0.6 }}
          >
            Wrong Password!
          </motion.p>
        </div>
      ) : (<></>)}
      
      <div className="flex mb-35">
        <motion.button
          initial={{ backgroundImage: "linear-gradient(to top, rgba(0, 110, 0, 0), white, white)" }}
          whileHover={{ backgroundImage: "linear-gradient(to top, rgba(0, 110, 0, 0.3), white, white)" }}
          transition={{ duration: 0.2, ease: "easeInOut" }}  
          className="align-left align-right green-button login-button" onClick={handleLogin}>Log In</motion.button>
      </div>
      
    </motion.div>
  );
};

export default Login;